import { useEffect } from 'react'
import { useResponsive } from '@/shared/hooks/useResponsive.ts'
import { getModalControlStore } from '@/domains/header/model/store.ts'

export const useCloseMenuOnResize = () => {
  const isDesktop = useResponsive('desktop')

  useEffect(() => {
    if (isDesktop) {
      getModalControlStore().closeModal()
    }
  }, [isDesktop])
}
